import { render, staticRenderFns } from "./IncomingCall.vue?vue&type=template&id=c72ff4ac&scoped=true"
import script from "./IncomingCall.vue?vue&type=script&lang=js"
export * from "./IncomingCall.vue?vue&type=script&lang=js"
import style0 from "./IncomingCall.vue?vue&type=style&index=0&id=c72ff4ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72ff4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72ff4ac')) {
      api.createRecord('c72ff4ac', component.options)
    } else {
      api.reload('c72ff4ac', component.options)
    }
    module.hot.accept("./IncomingCall.vue?vue&type=template&id=c72ff4ac&scoped=true", function () {
      api.rerender('c72ff4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/videoCall/IncomingCall.vue"
export default component.exports